<div [ngClass]="(messageType$ | async) === ASSIGNEMTN_STATUS_MESSAGE_TYPES.ERROR ? 'error-box' : 'warning-box'">
    <em class="material-icons">warning</em>

    <div [ngSwitch]="this.assignmentStatusCode$ | async">
        <div *ngSwitchCase="'-100'"><ng-container *ngTemplateOutlet="_100"></ng-container></div>
        <div *ngSwitchCase="'-101'"><ng-container *ngTemplateOutlet="_101"></ng-container></div>
        <div *ngSwitchCase="'-102'"><ng-container *ngTemplateOutlet="_102"></ng-container></div>
        <div *ngSwitchCase="'-103'"><ng-container *ngTemplateOutlet="_103"></ng-container></div>
        <div *ngSwitchCase="'-104'"><ng-container *ngTemplateOutlet="_104"></ng-container></div>
        <div *ngSwitchCase="'-105'"><ng-container *ngTemplateOutlet="_105"></ng-container></div>
        <div *ngSwitchCase="'-107'"><ng-container *ngTemplateOutlet="_107"></ng-container></div>
        <div *ngSwitchCase="'-110'"><ng-container *ngTemplateOutlet="_110"></ng-container></div>
        <div *ngSwitchCase="'-111'"><ng-container *ngTemplateOutlet="_111"></ng-container></div>
        <div *ngSwitchCase="'-200'"><ng-container *ngTemplateOutlet="_200"></ng-container></div>
        <div *ngSwitchCase="'-201'"><ng-container *ngTemplateOutlet="_201"></ng-container></div>
        <div *ngSwitchCase="'-202'"><ng-container *ngTemplateOutlet="_202"></ng-container></div>
        <div *ngSwitchCase="'-203'"><ng-container *ngTemplateOutlet="_203"></ng-container></div>
        <div *ngSwitchCase="'-204'"><ng-container *ngTemplateOutlet="_204"></ng-container></div>
        <div *ngSwitchCase="'-205'"><ng-container *ngTemplateOutlet="_205"></ng-container></div>
        <div *ngSwitchCase="'-206'"><ng-container *ngTemplateOutlet="_206"></ng-container></div>
        <div *ngSwitchCase="'-207'"><ng-container *ngTemplateOutlet="_207"></ng-container></div>
        <div *ngSwitchCase="'-208'"><ng-container *ngTemplateOutlet="_208"></ng-container></div>
        <div *ngSwitchCase="'-299'"><ng-container *ngTemplateOutlet="_299"></ng-container></div>
        <div *ngSwitchDefault><ng-container *ngTemplateOutlet="default"></ng-container></div>
    </div>
</div>

<ng-template #_100
    >{{ (surveyName$ | async) ? (surveyName$ | async) : 'This survey' }} does not allow continuing education credits. Contact the Site
    Administrator</ng-template
>

<ng-template #_101
    ><span>This kit has not been received. </span>
    <span><a appContactCap>You may contact the CAP.</a></span></ng-template
>

<ng-template #_102>This kit is being processed. Please allow 1-2 business days to complete processing.</ng-template>

<ng-template #_103> This Kit # is associated with another user ID. Enter a different Kit #.</ng-template>

<ng-template #_104
    >This kit does not meet the minimum number of responses required. You may
    <a appContactCap>contact the CAP</a></ng-template
>

<ng-template #_105>You have entered an invalid Kit # / CAP # combination. Re-enter Kit # and CAP #.</ng-template>

<ng-template #_107
    ><div>{{ (surveyName$ | async) ? (surveyName$ | async) : 'This survey' }} does not allow continuing education credits. You may:</div>
    <div>
        <ul>
            <li>Contact your administrator</li>
            <li><a appContactCap>Contact the CAP</a></li>
        </ul>
    </div></ng-template
>

<ng-template #_110>This kit was faxed after due date. You may <a appContactCap>contact the CAP</a></ng-template>

<ng-template #_111
    >There is another kit # assigned to your user ID{{ (surveyName$ | async) ? (' for ' + (surveyName$ | async)) : '' }}.
    You may contact your administrator.</ng-template
>
<ng-template #_200>This Kit # is associated with another user ID. Enter a different Kit #.</ng-template>

<ng-template #_201
    >You have already claimed credit{{ (surveyName$ | async) ? (' for ' + (surveyName$ | async)) : '' }} with a different kit #. You may contact your
    administrator.</ng-template
>

<ng-template #_202
    ><div>There is no survey/activity found for this CAP # / Kit # combination.</div>
    <div>You may:</div>
    <div>
        <ul>
            <li>Enter a different CAP # and Kit #</li>
            <li>Contact your administrator</li>
        </ul>
    </div></ng-template
>

<ng-template #_203
    ><div>There is no survey/activity found for this CAP # / Kit # combination.</div>
    <div>You may:</div>
    <div>
        <ul>
            <li>Enter a different CAP # and Kit #</li>
            <li>Contact your administrator</li>
        </ul>
    </div></ng-template
>

<ng-template #_204
    ><div>There is no survey/activity found for this CAP # / Kit # combination.</div>
    <div>You may:</div>
    <div>
        <ul>
            <li>Enter a different CAP # and Kit #</li>
            <li>Contact your administrator</li>
        </ul>
    </div></ng-template
>

<ng-template #_205>Multiple activity codes have been found for this kit number.</ng-template>

<ng-template #_206>You have already claimed this kit #. You may contact your administrator.</ng-template>

<ng-template #_207>This Kit # is associated with another user ID. Enter a different Kit #.</ng-template>

<ng-template #_208
    >You have already claimed credit for {{ surveyName$ | async }} with a different kit #. You may contact your
    administrator.</ng-template
>

<ng-template #_299
    ><div>An error occured when transmitting your completion to the Education site for credit, please <a appContactCap>contact us</a> with the following: </div>
    <div>
        <ul>
            <li>CAP Personal ID</li>
            <li>CAP/Kit#</li>
        </ul>
    </div></ng-template
>

<ng-template #default
    >We are sorry, an unexpected error occurred while processing your request.
    <a appContactCap>Contact the CAP</a>.</ng-template
>
